import {Mental2SymbolStates} from "../enums/Enum";
import {Symbol} from "./Symbol";
import TrackEntry = PIXI.spine.core.TrackEntry;

export class TombStoneSymbol extends Symbol {
    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
    }

    init(symbolName: string, initState: Mental2SymbolStates, index: number) {
        super.init(symbolName, initState, index);
    }

    clearAnimations() {
        super.clearAnimations();
    }

    public setResizeState(animName: string): TrackEntry {
        if (animName != "blur") {
            animName = "198_to_198";
        }
        return super.setResizeState(animName, true);
    }
}